// FINAL MODIFIED CODE AFTER NIGHT DEV PUSH
/* eslint-disable react/no-unstable-nested-components */
import { useEffect, useState } from 'react';
import {
  RouteObject,
  RouterProvider,
  createBrowserRouter,
  redirect
} from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import Storage from 'src/utils/storage/storage';
import MaintainancePage from './pages/core/default/MaintainancePage';
import NoAuthenticationPage from './pages/core/default/NoAuthenticationPage';
import SimulationHome from 'src/pages/analytics/simulator/home/simulator-home';
import Planner from 'src/pages/analytics/simulator/planner_v2/planner';
import Innovation from 'src/pages/analytics/simulator/innovation/innovation';
import Delist from 'src/pages/analytics/simulator/delist/delist';
import Renovation from 'src/pages/analytics/simulator/renovation/renovation';
import ScenarioManager from 'src/pages/analytics/simulator/scenario-manager/scenario-manager';
import ScenarioComparison from 'src/pages/analytics/simulator/scenario-comparison/component/scenario-comparison';
import { getSideNavBarData } from 'src/components/layout/appDrawer/app-drawer-slice-async-thunk';
import PowerBIEmbedContainer from 'src/pages/analytics/power-bi-embed-container/power-bi-embed-container';
import Login from 'src/pages/core/authentication/Login';
import ClusterSummary from 'src/pages/analytics/simulator/cluster-summary/cluster-summary';
import PricingSimulator from 'src/pages/analytics/simulator/pricing-simulator/components/pricing-simulator';
import Home from 'src/pages/core/default/Home';
import { ENDPOINTS } from 'src/constants';
import fetchUserMetadata, {
  fetchScreensMetadata
} from 'src/components/user/user/api/user-api';
import SimulationSummary from 'src/pages/analytics/simulator/simulation-summary/simulation-summary';
import { IRouteMetadata } from 'src/components/layout/appDrawer/types/auth-response.model';
// BELOW ARE THE IMPORT ADDED ON 04-APRIL-2024 BY RISHAD KP
import LogoutRedirect from 'src/pages/core/authentication/LogoutRedirect';
import MicrosoftRedirect from 'src/pages/core/authentication/MicrosoftRedirect';
import LoginRedirect from 'src/pages/core/authentication/LoginRedirect';
import { Navigate, useNavigate } from 'react-router';
import Alerts from 'src/pages/core/default/Alerts';
import LandingWrapper from 'src/pages/analytics/landing/components/landing-wrapper/landing-wrapper';
import Details from 'src/pages/core/details/Details';
import NotFound from 'src/pages/core/support/NotFound';
import ComingSoon from 'src/pages/core/support/ComingSoon';
import UserSettings from 'src/pages/core/default/UserSettings';
import AdminSettings from 'src/pages/core/admin/AdminSettings';
import Feed from 'src/pages/core/default/Feed';
import Boards from 'src/pages/core/details/Boards';
import Capability from 'src/pages/core/details/Capability';
import Product from 'src/pages/core/details/Product';
import Region from 'src/pages/core/details/Region';
import Segment from 'src/pages/core/details/Segment';
import Market from 'src/pages/core/details/Market';
import InactiveUser from 'src/pages/core/support/InactiveUser';
// import { useAuth } from './hooks/useAuth';
// import {
//   MainGlobalLayout,
//   ProtectedGlobalLayout
// } from './components/layout/Layout';
import { useIsAuthenticated } from '@azure/msal-react';
import MainLayout from './components/layout/MainLayout/MainLayout';
import UserLayout from './components/layout/UserLayout/UserLayout';
import AppLoadingSkeleton from './components/skeletons/AppLoadingSkeleton';
import ErrorPage from './pages/core/default/ErrorPage';
import CountryParamHandler from './CountryParamHandler';

const KEY_TO_COMPONENT_MAP = {
  home: <LandingWrapper />,
  // home: RedirectToLanding(),
  login: <Login />,
  planner: <Planner />,
  innovation: <Innovation />,
  delist: <Delist />,
  pricing_and_distribution: <PricingSimulator />,
  // pricing_and_distribution: <MultiPricePricingSimulator />,
  pricing_simulator: <SimulationHome />,
  renovation: <Renovation />,
  summary: <SimulationSummary />,
  scenario_manager: <ScenarioManager />,
  scenario_comparison: <ScenarioComparison />,
  cluster_summary: <ClusterSummary/>,

  logoutredirect: <LogoutRedirect />,
  microsoftredirect: <MicrosoftRedirect />,
  loginredirect: <LoginRedirect />,
  alerts: <Alerts />,
  landing: <LandingWrapper />,
  details: <Details />,
  notfound: <NotFound />,
  comingsoon: <ComingSoon />,
  usersettings: <UserSettings />,
  adminsettings: <AdminSettings />,
  feed: <Feed />,
  boards: <Boards />,
  capability: <Capability />,
  product: <Product />,
  region: <Region />,
  segment: <Segment />,
  market: <Market />,
  inactiveuser: <InactiveUser />,
  maintainancepage: <MaintainancePage />,
  noauthenticationpage: <NoAuthenticationPage />,
  errorPage: <ErrorPage />
};

function createRoutesFromMetadata(
  routesMetadata: IRouteMetadata[]
): RouteObject[] {
  const routes: RouteObject[] = [];
  routesMetadata?.forEach((routeMetadata) => {
    if (routeMetadata.parent.is_leaf) {
      routes.push({
        path: routeMetadata.parent.route_url,
        element: routeMetadata.parent.is_pb_page ? (
          <PowerBIEmbedContainer
            component={{ pbiEmbedUrl: routeMetadata.parent.embed_url }}
            routesMetaDataPBI={routeMetadata}
          />
        ) : (
          KEY_TO_COMPONENT_MAP[routeMetadata.parent.name]
        ),
        errorElement: <ErrorPage />
      });
    }
    if (routeMetadata.children.length) {
      routes.push(...createRoutesFromMetadata(routeMetadata.children));
    }
  });
  return routes;
}


const HOME_ROUTE = {
  path: ENDPOINTS.homeUrl,
  element: <LandingWrapper />,
  loader: async () => {
    const { userMeta } = Storage.getUserMetadata();
    if (!userMeta) {
      return fetchUserMetadata().then((response) =>
        Storage.setUserMetadata({
          userMeta: response.data[0],
          screenMeta: []
        })
      );
    }
    return Promise.resolve(true);
  },
  errorElement: <ErrorPage />
};

const OPEN_ROUTES = [
  {
    path: ENDPOINTS.loginRedirect,
    element: <LoginRedirect />,
    errorElement: <ErrorPage />
  },
  {
    path: '/404',
    element: <NotFound />,
    errorElement: <ErrorPage />
  },
  {
    path: '/app/sign_in',
    element: <NotFound />,
    errorElement: <ErrorPage />
  },
  {
    path: ENDPOINTS.loginUrl,
    element: <Navigate to='/' />,
    errorElement: <ErrorPage />
  },
  {
    path: '/app/login',
    element: <Navigate to='/' />,
    errorElement: <ErrorPage />
  },
  {
    path: ENDPOINTS.logoutUrl,
    element: <LogoutRedirect />,
    errorElement: <ErrorPage />
  },
  {
    path: '/dev-login',
    element: <Login />,
    errorElement: <ErrorPage />
  },
  // commenting to handle refresh issue
  // {
  //   path: '*',
  //   element: <NotFound />,
  //   errorElement: <ErrorPage />
  // },
  {
    path: '',
    element: <Navigate to='/home' />,
    errorElement: <ErrorPage />
  },
  {
    path: ENDPOINTS.maintainance,
    element: <MaintainancePage />,
    errorElement: <ErrorPage />
  },
  {
    path: ENDPOINTS.noaccess,
    element: <NoAuthenticationPage />,
    errorElement: <ErrorPage />
  },
  {
    path: ENDPOINTS.errorPage,
    element: <ErrorPage />
  },
  {
    path: '/powerbi-embed',
    element: (
    <PowerBIEmbedContainer
      component={{ pbiEmbedUrl: '' }}
      fromClusterSummary={true}
    />
  ),
  errorElement: <ErrorPage />
  }
];

function AppRouter() {
  const appDispatch = useAppDispatch();
  const [routes, setRoutes] = useState<RouteObject[]>([
    ...OPEN_ROUTES,
    HOME_ROUTE
  ]);

  const validRoutes = [];
  // const { isAuthenticated } = useAuth();
  const { isTokenSet } = useAppSelector((state) => state.auth);
  const [openroutesMPTTData, setOpenRoutesMPTTData] = useState(null);
  const [authroutesMPTTData, setAuthRoutesMPTTData] = useState(null);

  const isUserAuthenticated = useIsAuthenticated();

  const [isFetchingRoutes, setIsFetchingRoutes] = useState(false);

  useEffect(() => {
    setIsFetchingRoutes(true);

    if (!isTokenSet) {
      setOpenRoutesMPTTData(OPEN_ROUTES);
    } else {
      const { userMeta } = Storage.getUserMetadata();
      let sourceID = 1;
      if (userMeta) {
        sourceID = userMeta.source;
        appDispatch(getSideNavBarData({ sourceID })).then((response) => {
          const routesMetadata = response.payload as IRouteMetadata[];
          setAuthRoutesMPTTData([
            ...OPEN_ROUTES,
            ...createRoutesFromMetadata(routesMetadata)
          ]);
          setIsFetchingRoutes(false);
        });
      } else {
        const currUserMeta = fetchUserMetadata().then((res) => {
          sourceID = res.data[0].source;
          appDispatch(getSideNavBarData({ sourceID })).then((response) => {
            const routesMetadata = response.payload as IRouteMetadata[];
            setAuthRoutesMPTTData([
              ...OPEN_ROUTES,
              ...createRoutesFromMetadata(routesMetadata)
            ]);
            setIsFetchingRoutes(false);
          });
        })
          .catch(() => {
            setIsFetchingRoutes(false)
          })
      }
    }
  }, [isTokenSet]);

  validRoutes.push({
    path: '/',
    element: (
      <CountryParamHandler>
        <UserLayout />
      </CountryParamHandler>
    ),
    children: authroutesMPTTData !== null ? authroutesMPTTData : routes
  });
  console.log('valid routes: ', validRoutes);
  if (isFetchingRoutes) {
    return (
      <div>
        <AppLoadingSkeleton />
      </div>
    );
  }
  return <RouterProvider router={createBrowserRouter(validRoutes)} />;
}

export default AppRouter;
